/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions
 */
export interface FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions
     */
    AllowedTransferFromMyGames: boolean;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(value: object): value is FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions {
    if (!('AllowedTransferFromMyGames' in value) || value['AllowedTransferFromMyGames'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AllowedTransferFromMyGames': json['AllowedTransferFromMyGames'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AllowedTransferFromMyGames': value['AllowedTransferFromMyGames'],
    };
}

